import { Expose } from "class-transformer";

export class RemoveValuationProjectsDto {
  @Expose()
  valuationId: string;

  @Expose()
  valuationHasProjectIds: string[];
}
